import { render, staticRenderFns } from "./notifyMessage.vue?vue&type=template&id=06cba534&scoped=true"
import script from "./notifyMessage.vue?vue&type=script&lang=js"
export * from "./notifyMessage.vue?vue&type=script&lang=js"
import style0 from "./notifyMessage.vue?vue&type=style&index=0&id=06cba534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cba534",
  null
  
)

export default component.exports